import { LearnLayout } from "./Layout/LearnLayout";

export const CollabWVo = () => {
  return (
    <LearnLayout videoUrl="https://share.descript.com/embed/QgggZEb7cxt?t=110.005886">
      <h3>Collaborating With Vo</h3>
      <p>
        Building a company roadmap is hard and getting the words right is even
        harder. You know what you want to say about your Vision, Mission or Peak
        Ambition, but when you sit down to write, clarity can feel hard to come
        by. You might feel stuck, spending hours on a handful of sentences,
        rewriting the same paragraph multiple times. Or even worse, you may feel
        like you have "writer's block."
      </p>
      <p>
        Voice Writing with Vo solves this. You talk, Vo writes. You iterate
        together until it's perfect.
      </p>

      <h4>What Is It</h4>
      <p>
        Vo is your personal AI agent for creating purpose-driven documents, like
        your Strategic Company Roadmap as one example. Instead of fighting
        through writer's block and inefficient editing cycles, you just think
        out loud, and Vo turns your conversation into documents or Roadmap
        Building Blocks you & your team can actually use. No perfect prompts
        required, just talk.
      </p>

      <h4>How It Works</h4>
      <p className="font-bold">1. Talk through your thinking</p>
      <p>
        Click Configure Roadmap in your app and you'll see your workspace with
        Vo. Hit record and explain what you're building, the same way you'd
        explain it to a colleague. You don't need exact wording and don't have
        to worry about pauses or filler words. Vo understands context, sometimes
        better than humans do. So when an idea feels complicated, just talk it
        through.
      </p>
      <p className="font-bold">2. Vo delivers a draft in seconds</p>
      <p>
        Here's a real example. Ross had a vision statement drafted, but it was
        far too long and didn't feel right. He hit record and said:
      </p>
      <p className="italic">
        "I like this vision statement, but it's way too long. It needs to be one
        sentence. I don't want to say visionary teams—I want to say founder-led
        teams. These teams need to feel supported and easily able to use that
        unified view to make decisions."
      </p>
      <p>
        Vo took 10 seconds and delivered a one-sentence version that was clearer
        and better.
      </p>
      <p className="font-bold">3. Iterate until it's right</p>
      <p>
        If your first draft not perfect, just talk some more. Tell Vo in plain
        English what to change. You can work together the same way as you would
        with a colleague or friend, except Vo writes exceptionally well and
        knows how to transform your spoken words into useful, well written
        documents.
      </p>
      <p>Review. Give feedback. Iterate. It takes minutes, not hours.</p>

      <h4>The Result</h4>
      <p>When you build with Vo, you get:</p>
      <p>
        <strong>No more blank page paralysis:</strong> By just talking through
        your ideas, Vo turns them into crystal-clear strategy. You never face
        writer's block because you're never actually writing.
      </p>
      <p>
        <strong>Strategic Roadmap content that's ready to use:</strong> All your
        roadmap building blocks from vision to peak ambition turn out clear,
        concise and actionable. Your team can read them and know exactly where
        you're heading.
      </p>
      <p>
        <strong>A collaborator who's always available:</strong> Working on
        strategy at midnight? Vo's there. Need to create the perfect slides
        before your board meeting? Vo's ready to help.
      </p>
      <p>
        You now have access to an expert collaborator with you at all times.
      </p>
      <h4>How Vojomo Helps</h4>
      <p>
        Click Configure Roadmap and start talking to Vo about what you're
        building and the outcomes that matter most to you. Vo will help you
        shape it into a roadmap your team can use to make more aligned decisions
        every single day.
      </p>
    </LearnLayout>
  );
};
